import settings from '../settings.js'

import surveySupModalHtml from '../templates/survey-modal-sup.html'

const $inject = ['$scope', 'common', 'UserService', '$ionicModal', 'SurveyService']

function AccountCtrl(scope, common, UserService, ionicModal, SurveyService) {
    scope.settings = settings

    scope.notifications = common.settings.notifications;

    scope.survey = {};

    scope.setLanguage = UserService.setLanguage;
    scope.getLangCode = UserService.getLangCode;

    SurveyService.baseUrl = settings.baseUrl;

    scope.openSurvey = (hash) => common.openSurvey(hash, scope);
    scope.saveSurvey = common.getBasicSurveySave(scope, 'surveyModal');

    ionicModal.fromTemplateUrl(surveySupModalHtml, {
        scope: scope
    }).then((modal) => {
        scope.surveyModal = modal;
    });

    scope.actions = {
        toggleRegister: (mode) => {
            console.log(`[${performance.now()}] User toggled push notifications to ${(scope.notifications.enabled ? "ENABLED" : "DISABLED")}`);
            common.saveSettings();
        }
    };
    
    scope.$on('$ionicView.afterEnter', () => {
        scope.user = UserService.user;
    });
}

AccountCtrl.$inject = $inject

export default AccountCtrl